import {
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Typography
} from '@mui/material'
import { Stack } from '@mui/system'
import { useState } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

import useLoginAndSignUp from '../../hooks/useLoginAndSignUp/useLoginAndSignUp'
import { AppRoutes } from '../../models'
import { EmployeeRole, GetUsersWithPermissionActEnum } from '../../sdk'
import {
  getUsernameFromDummyEmail,
  isDummyEmail
} from '../../utils/checkDummyEmail/checkDummyEmail'
import { FormMessage } from '../FormMessage'

export const SwitchUserForm = ({
  employee,
  setIsUserSelected,
  submitCallback
}: {
  employee: EmployeeRole
  setIsUserSelected: (e: EmployeeRole | undefined) => void
  submitCallback: () => void
}) => {
  const { loginAndSignUp, errorMessage, loading } = useLoginAndSignUp()
  const navigate = useNavigate()
  const location = useLocation()

  const [password, setPassword] = useState('')
  const handleSwitch = async () => {
    const user = await loginAndSignUp(
      employee.userProfile!.email!,
      password,
      true
    )
    if (user) {
      submitCallback()
      if (
        !user.permissions.has(
          GetUsersWithPermissionActEnum.AccessAdminReports
        ) &&
        matchPath(`${AppRoutes.REPORTS}/*`, location.pathname)
      ) {
        navigate(AppRoutes.WORK_IN_PROGRESS)
      }
    }
  }
  return (
    <>
      <DialogContent>
        <Typography variant="subtitle1">
          Enter the password to the account to continue
        </Typography>
        {errorMessage && (
          <FormMessage message={errorMessage} testId="loginError" />
        )}
        <form>
          <Stack spacing={1} mt={1}>
            <TextField
              variant="standard"
              label="Email or Username"
              type="text"
              value={
                isDummyEmail(employee.userProfile!.email!)
                  ? getUsernameFromDummyEmail(employee.userProfile!.email!)
                  : employee.userProfile!.email!
              }
              id="email"
              name="email"
              required
              data-testid="emailField"
              disabled={true}
            />
            <TextField
              type="password"
              id="password"
              label="Password"
              variant="standard"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
              data-testid="passwordField"
            />
          </Stack>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsUserSelected(undefined)}>Back</Button>
        <Button disabled={loading} onClick={handleSwitch} variant="contained">
          {loading ? 'Signing In...' : 'Switch'}
        </Button>
      </DialogActions>
    </>
  )
}
